const permissions = [
  {
    key: "admin_perm",
    label: "Administrator",
  },
  {
    key: "user_perm",
    label: "Manage Staff",
  },
  {
    key: "branch_perm",
    label: "Health Centres",
  },
  {
    key: "product_perm",
    label: "Catalog Manager",
  },
  {
    key: "booking_perm",
    label: "Manage Bookings",
  },
  {
    key: "accounting_perm",
    label: "Settlements",
  },
  {
    key: "feedback_perm",
    label: "Feedback & Ratings",
  },
  {
    key: "help_perm",
    label: "Help & Support",
  },
  {
    key: "log_perm",
    label: "Logs",
  },
  {
    key: "emergency_perm",
    label: "Emergency",
  },
  {
    key: "dashboard_perm",
    label: "Dashboard",
  },
];

export default permissions;
